// import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import axiosInstance from 'Services/APIService';
// import { fetchIncidents } from '../carporateServices/IncidentsListSlice';

// // Define the form data type for both main and follow-up forms
// export interface RestrictivePracticesFormData {
//   id?: string;
//   date: string;
//   time: string;
//   location: string;
//   client_name: string;
//   support_worker_name: string;
//   type_of_practice: string;
//   reason_for_use: string;
//   approved_in_plan: string;
//   description: string;
//   immediate_actions: string;
//   reported_to_management: string;
//   recommendations: string;
//   support_worker_signature: string;
//   date_completed: string;
//   photo?: File|string;
//   client_email?: string;
// }

// export interface RestrictivePracticesFollowUpFormData {
//   id?: string;
//   reported_to_management: string;
//   client_email?: string;
//   client_name?: string;
//   support_worker_name?: string;
//   photo?: string;
// }

// // Define the state type
// export interface RestrictivePracticesIncidentState {
//   loading: boolean;
//   message: string | null;
//   error: string | null;
// }

// // Define the initial state
// const initialState: RestrictivePracticesIncidentState = {
//   loading: false,
//   message: null,
//   error: null
// };

// // Helper function to convert file to base64
// const convertFileToBase64 = (file: File): Promise<string> => {
//   return new Promise((resolve, reject) => {
//     const reader = new FileReader();
//     reader.onload = () => resolve(reader.result as string);
//     reader.onerror = (error) => reject(error);
//     reader.readAsDataURL(file);
//   });
// };

// // Async thunk for submitting restrictive practices incident data
// export const submitRestrictivePracticesIncident = createAsyncThunk<
//   { message: string },
//   RestrictivePracticesFormData,
//   { rejectValue: string }
// >('restrictivePracticesIncident/submit', async (formData, { rejectWithValue, dispatch }) => {
//   try {
//     // Retrieve data from localStorage
//     const project = JSON.parse(localStorage.getItem('selectedProject') || '{}') as {
//       projectId?: string;
//     };
//     const service = JSON.parse(localStorage.getItem('servicesState') || '{}') as {
//       selectedServiceTitle?: string;
//     };
//     const selectedClient = JSON.parse(localStorage.getItem('selectedClient') || '{}') as {
//       email?: string;
//     };
//     const client_email = selectedClient.email || formData.client_email || '';

//     if (!project.projectId || !service.selectedServiceTitle || !client_email) {
//       return rejectWithValue('Missing project, service, or client information in localStorage');
//     }

//     let photoField: string = '';
//     if (formData.photo instanceof File) {
//       photoField = await convertFileToBase64(formData.photo);
//     } else if (typeof formData.photo === 'string') {
//       photoField = formData.photo;
//     }


//     // Construct payload with all fields, using defaults for optional fields
//     const payload = {
//       id: formData.id || '',
//       group_id: project.projectId,
//       service_name_id: service.selectedServiceTitle,
//       client_email,
//       date: formData.date,
//       time: formData.time,
//       location: formData.location,
//       client_name: formData.client_name,
//       support_worker_name: formData.support_worker_name,
//       type_of_practice: formData.type_of_practice,
//       reason_for_use: formData.reason_for_use,
//       approved_in_plan: formData.approved_in_plan,
//       description: formData.description,
//       immediate_actions: formData.immediate_actions,
//       reported_to_management: formData.reported_to_management || '',
//       recommendations: formData.recommendations,
//       support_worker_signature: formData.support_worker_signature,
//       date_completed: formData.date_completed,
//       photo: photoField
//     };

//     const response = await axiosInstance.post('/ndis/form/restrictive-practices-incident', payload);
//     await dispatch(fetchIncidents({ client_email })).unwrap();
//     return response.data;
//   } catch (error: any) {
//     return rejectWithValue(
//       error.response?.data?.message || 'Failed to submit restrictive practices incident'
//     );
//   }
// });

// const restrictivePracticesIncidentSlice = createSlice({
//   name: 'restrictivePracticesIncident',
//   initialState,
//   reducers: {
//     clearRestrictivePracticesIncidentState: (state) => {
//       state.loading = false;
//       state.message = null;
//       state.error = null;
//     }
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(submitRestrictivePracticesIncident.pending, (state) => {
//         state.loading = true;
//         state.message = null;
//         state.error = null;
//       })
//       .addCase(submitRestrictivePracticesIncident.fulfilled, (state, action) => {
//         state.loading = false;
//         state.message =
//           action.payload.message || 'Restrictive practices incident submitted successfully';
//         state.error = null;
//       })
//       .addCase(submitRestrictivePracticesIncident.rejected, (state, action) => {
//         state.loading = false;
//         state.message = null;
//         state.error = action.payload as string;
//       });
//   }
// });

// export const { clearRestrictivePracticesIncidentState } = restrictivePracticesIncidentSlice.actions;
// export default restrictivePracticesIncidentSlice.reducer;



// Slice definition
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'Services/APIService';
import { fetchIncidents } from '../carporateServices/IncidentsListSlice';

// Define the form data type for both main and follow-up forms
export interface RestrictivePracticesFormData {
  id?: string;
  date: string;
  time: string;
  location: string;
  client_name: string;
  support_worker_name: string;
  type_of_practice: string;
  reason_for_use: string;
  approved_in_plan: string;
  description: string;
  immediate_actions: string;
  reported_to_management: string;
  resolved?: string;
  recommendations: string;
  support_worker_signature: string;
  date_completed: string;
  photo?: File | string;
  client_email?: string;
}

export interface RestrictivePracticesFollowUpFormData {
  id?: string;
  reported_to_management: string;
  resolved: string;
  client_email?: string;
  client_name?: string;
  support_worker_name?: string;
  photo?: string;
}

// Define the state type
export interface RestrictivePracticesIncidentState {
  loading: boolean;
  message: string | null;
  error: string | null;
}

// Define the initial state
const initialState: RestrictivePracticesIncidentState = {
  loading: false,
  message: null,
  error: null
};

// Helper function to convert file to base64
const convertFileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
    reader.readAsDataURL(file);
  });
};

// Async thunk for submitting restrictive practices incident data
export const submitRestrictivePracticesIncident = createAsyncThunk<
  { message: string },
  RestrictivePracticesFormData,
  { rejectValue: string }
>('restrictivePracticesIncident/submit', async (formData, { rejectWithValue, dispatch }) => {
  try {
    // Retrieve data from localStorage
    const project = JSON.parse(localStorage.getItem('selectedProject') || '{}') as {
      projectId?: string;
    };
    const service = JSON.parse(localStorage.getItem('servicesState') || '{}') as {
      selectedServiceTitle?: string;
    };
    const selectedClient = JSON.parse(localStorage.getItem('selectedClient') || '{}') as {
      email?: string;
    };
    const client_email = selectedClient.email || formData.client_email || '';

    if (!project.projectId || !service.selectedServiceTitle || !client_email) {
      return rejectWithValue('Missing project, service, or client information in localStorage');
    }

    let photoField: string = '';
    if (formData.photo instanceof File) {
      photoField = await convertFileToBase64(formData.photo);
    } else if (typeof formData.photo === 'string') {
      photoField = formData.photo;
    }

    // Construct payload with all fields, using defaults for optional fields
    const payload = {
      id: formData.id || '',
      group_id: project.projectId,
      service_name_id: service.selectedServiceTitle,
      client_email,
      date: formData.date,
      time: formData.time,
      location: formData.location,
      client_name: formData.client_name,
      support_worker_name: formData.support_worker_name,
      type_of_practice: formData.type_of_practice,
      reason_for_use: formData.reason_for_use,
      approved_in_plan: formData.approved_in_plan,
      description: formData.description,
      immediate_actions: formData.immediate_actions,
      reported_to_management: formData.reported_to_management || '',
      resolved: formData.resolved || '',
      recommendations: formData.recommendations,
      support_worker_signature: formData.support_worker_signature,
      date_completed: formData.date_completed,
      photo: photoField
    };

    const response = await axiosInstance.post('/ndis/form/restrictive-practices-incident', payload);
    await dispatch(fetchIncidents({ client_email })).unwrap();
    return response.data;
  } catch (error: any) {
    return rejectWithValue(
      error.response?.data?.message || 'Failed to submit restrictive practices incident'
    );
  }
});

const restrictivePracticesIncidentSlice = createSlice({
  name: 'restrictivePracticesIncident',
  initialState,
  reducers: {
    clearRestrictivePracticesIncidentState: (state) => {
      state.loading = false;
      state.message = null;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitRestrictivePracticesIncident.pending, (state) => {
        state.loading = true;
        state.message = null;
        state.error = null;
      })
      .addCase(submitRestrictivePracticesIncident.fulfilled, (state, action) => {
        state.loading = false;
        state.message =
          action.payload.message || 'Restrictive practices incident submitted successfully';
        state.error = null;
      })
      .addCase(submitRestrictivePracticesIncident.rejected, (state, action) => {
        state.loading = false;
        state.message = null;
        state.error = action.payload as string;
      });
  }
});

export const { clearRestrictivePracticesIncidentState } = restrictivePracticesIncidentSlice.actions;
export default restrictivePracticesIncidentSlice.reducer;
